import React from "react";
import { motion } from "framer-motion";
import { fadeIn } from "../Transitions";

const About = () => {
  return (
    <div className="section1" id="about">
      <div className="mb-8">
        <motion.h2
          variants={fadeIn("right", 0.3)}
          initial="hidden"
          whileInView={"show"}
          viewport={{ once: false, amount: 0.7 }}
          className="text-[1.5rem] font-bold "
        >
          About me
        </motion.h2>
        <motion.div
          variants={fadeIn("right", 0.3)}
          initial="hidden"
          whileInView={"show"}
          viewport={{ once: false, amount: 0.7 }}
          className="w-14 h-[3px] bg-gradient-to-r from-gray-200 via-gray-400 to-gray-600 rounded-sm"
        ></motion.div>
      </div>

      <p
        variants={fadeIn("right", 0.3)}
        initial="hidden"
        whileInView={"show"}
        viewport={{ once: false, amount: 0.7 }}
        className="opacity-80 text-[0.9rem]"
      >
        Welcome to my portfolio, let me tell you about my journey.
        <br /> As a dancer, I have a unique ability to express myself through
        movement, bringing style, and storytelling to life on stage or wherever
        I perform. I have spent years training my body and mind to execute
        precise and intricate movements with grace and fluidity, often pushing
        myself to the limits of my physical and artistic abilities. Throughout
        my dance career, I've won many dance competitions, performed at a half
        time show at the Barclays Center in Brooklyn, and was featured on BET's
        106 & Park for winning their contest for best "Instagram dancer of the
        week".
        <br />
        <br />
        As a photographer, my goal is to capture memories that last a lifetime.
        With a keen eye for detail and a passion for capturing the essence of my
        subjects, I strive to provide clients with a truly unique and personal
        experience. My style is a blend of portraits, streets, boudoir, and
        products, creating timeless images that tell a story. I am dedicated to
        customer satisfaction and take pride in delivering high-quality images
        that truly reflect my clients' vision. If you're looking for a
        photographer who will go the extra mile to make your special moments
        unforgettable, I would love to be your choice.
        <br />
        <br />
        As a software engineer, the journey started when I attended The Marcy
        Lab School in 2022. The Marcy Lab School is a one year free program on
        web development to become a full stack developer. I have honed my skills
        in JavasSript, React, CSS3, HTML5, Bootstrap, Node.js, Express,
        PostgreSQL, OOP, Git, Figma, TailWind.CSS, and have demonstrated my
        ability to effectively design, develop, and maintain complex software
        systems such as this application you're currenlty visiting ( thank you
        😉). I have also worked on projects that required collaboration with
        cross-functional teams and have been successful in delivering results
        within tight deadlines.
      </p>
    </div>
  );
};

export default About;
